import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import './footer.component.css';
import { Modal } from 'react-bootstrap';
import TijoriLogo from '../../../assets/images/tijori-logo.png';
import FeedbackForm from '../../presentational/common/feedback_form/feedback_form.component';
import AppContext from '../../context';

const Footer = () => {
  const context = useContext(AppContext);
  const [fbModalVisible, setFbModalVisible] = useState(false);
  //responsive
  const [isMobile, setIsMobile] = useState(false);
  const [toolsVisible, setToolsVisible] = useState({
    tracking: false,
    research: false,
    policies: false,
    about: false,
  });
  const [isLoginModalVisible, setIsLoginModalVisible] = useState(false);

  const handleProfileItemClick = () => {
    if (!context.user.is_authenticated) {
      setIsLoginModalVisible(true);
      return;
    }
  };

  useEffect(() => {
    if (window.innerWidth <= 370) {
      setIsMobile(true);
    }
    const handleResize = _.debounce(() => {
      if (window.innerWidth <= 370 && !isMobile) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }, 100);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleExpCol = (tool) => {
    const defaultToolsVisible = {
      tracking: false,
      research: false,
      policies: false,
      about: false,
    };
    defaultToolsVisible[tool] = !toolsVisible[tool];
    setToolsVisible(defaultToolsVisible);
  };

  return (
    <>
      <footer>
        <section className="links">
          <div className="logo">
            <a href="/?r=n">
              <img src={TijoriLogo} alt="Tijori Finance" width="79" />
            </a>
          </div>
          <div
            className="tracking_tools exp-col mob"
            onClick={() => handleExpCol('tracking')}
          >
            <div className={`head ${isMobile ? 'head-underline' : ''}`}>
              TRACKING TOOLS
              <div
                className={`arrow ${toolsVisible['tracking'] ? 'up' : 'down'}`}
              ></div>
            </div>
            <ul
              style={{
                display: !isMobile
                  ? 'block'
                  : toolsVisible['tracking']
                  ? 'block'
                  : 'none',
              }}
            >
              <li>
                <a
                  href={
                    context.user.is_authenticated ? '/in/alerts' : undefined
                  }
                  onClick={() => handleProfileItemClick()}
                >
                  Alerts
                </a>
              </li>
              <li>
                <a
                  href={
                    context.user.is_authenticated
                      ? '/in/portfolio'
                      : '/in/portfolio/sample'
                  }
                >
                  Portfolio
                </a>
              </li>
              <li>
                <a
                  href={
                    context.user.is_authenticated
                      ? '/in/timeline'
                      : '/in/timeline/all'
                  }
                >
                  Timeline
                </a>
              </li>
              <li>
                <a
                  href={
                    context.user.is_authenticated ? '/in/watchlist' : undefined
                  }
                  onClick={() => handleProfileItemClick()}
                >
                  Watchlist
                </a>
              </li>
            </ul>
          </div>
          <div
            className="research_tools exp-col mob"
            onClick={() => handleExpCol('research')}
          >
            <div className={`head ${isMobile ? 'head-underline' : ''}`}>
              RESEARCH TOOLS
              <div
                className={`arrow ${toolsVisible['research'] ? 'up' : 'down'}`}
              ></div>
            </div>
            <ul
              style={{
                display: !isMobile
                  ? 'block'
                  : toolsVisible['research']
                  ? 'block'
                  : 'none',
              }}
            >
              <li>
                <a href="/?r=n">Company Search</a>
              </li>
              <li>
                <a href="/?r=n">Sector Search</a>
              </li>
              <li>
                <a href="/filter/popular-queries">Filter</a>
              </li>
              <li>
                <a href="/in/markets">Market Monitor</a>
              </li>
              <li>
                <a href="/in/macro">Macro Indicators</a>
              </li>
              <li>
                <a href="/in/raw-materials">Raw Materials</a>
              </li>
            </ul>
          </div>
          <div
            className="policies exp-col mob"
            onClick={() => handleExpCol('policies')}
          >
            <div className={`head ${isMobile ? 'head-underline' : ''}`}>
              POLICIES
              <div
                className={`arrow ${toolsVisible['policies'] ? 'up' : 'down'}`}
              ></div>
            </div>
            <ul
              style={{
                display: !isMobile
                  ? 'block'
                  : toolsVisible['policies']
                  ? 'block'
                  : 'none',
              }}
            >
              <li>
                <a href="/privacy-policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms-of-use">Terms of Use</a>
              </li>
              <li>
                <a href="/cancellation-policy">Cancellation Policy</a>
              </li>
            </ul>
          </div>
          <div
            className="about exp-col mob"
            onClick={() => handleExpCol('about')}
          >
            <div className={`head ${isMobile ? 'head-underline' : ''}`}>
              ABOUT
              <div
                className={`arrow ${toolsVisible['about'] ? 'up' : 'down'}`}
              ></div>
            </div>
            <ul
              style={{
                display: !isMobile
                  ? 'block'
                  : toolsVisible['about']
                  ? 'block'
                  : 'none',
              }}
            >
              <li>
                <a href="/features">Features</a>
              </li>
              <li>
                <a href="/whats-new">What's New</a>
              </li>
              <li>
                <a href="/plans">Pricing</a>
              </li>
            </ul>
          </div>
          <div className={`contact-us mob ${!isMobile ? 'd-none' : ''}`}>
            <div
              className={`head ${isMobile ? 'head-underline' : ''}`}
              onClick={() => setFbModalVisible(true)}
            >
              CONNECT WITH US
            </div>
            <div>
              <a
                target="_blank"
                href="https://www.instagram.com/tijorifinance/?hl=en"
                className="icon"
              >
                <i className="fa fa-instagram"></i>
              </a>
              <a
                target="_blank"
                href="https://twitter.com/Tijori1"
                className="icon"
              >
                <i className="fa fa-twitter"></i>
              </a>
            </div>
          </div>
        </section>
        <section className="copyright">
          <div>
            © {new Date().getFullYear()} Tijori Financial Services Private
            Limited | All rights reserved
            <div className="small-info-text">
              (formerly known as “Tijori Advisory Services Private Limited”)
            </div>
          </div>
          <div className="contact-us">
            <span
              className={`head ${isMobile ? 'head-underline' : ''}`}
              onClick={() => setFbModalVisible(true)}
            >
              CONNECT WITH US
            </span>
            <span className="mx-2"> | </span>
            <span>
              <a
                target="_blank"
                href="https://www.instagram.com/tijorifinance/?hl=en"
                className="icon"
              >
                <i className="fa fa-instagram"></i>
              </a>
              <a
                target="_blank"
                href="https://twitter.com/Tijori1"
                className="icon"
              >
                <i className="fa fa-twitter"></i>
              </a>
            </span>
          </div>
        </section>
      </footer>
      <FeedbackForm show={fbModalVisible} setShow={setFbModalVisible} />
      {/* sign up for free/login req modal */}
      <Modal
        show={isLoginModalVisible}
        centered
        onHide={() => setIsLoginModalVisible(false)}
        className="signup-free"
      >
        <Modal.Body className="text-center px-0">
          <div className="head">Login Required</div>
          <p className="info mb-0 mt-3">
            You need to be signed in to access this feature
          </p>
          <button
            className="signup-btn"
            onClick={() =>
              (window.location.href =
                window.location.origin + '/account/signup')
            }
          >
            SIGN UP FOR A FREE ACCOUNT
          </button>
          <div className="sign-in">
            Already have an account?{' '}
            <a href="/account/signin" className="sign-in-link">
              Sign In
            </a>
          </div>
        </Modal.Body>
        <div
          className="close-btn"
          onClick={() => setIsLoginModalVisible(false)}
        >
          &#10006;
        </div>
      </Modal>
    </>
  );
};

export default Footer;
